/* eslint no-tabs: 0, no-unused-vars: 0, operator-assignment: 0, 
 no-multi-assign: 0, camelcase: 0, consistent-return: 0, max-len: 0, no-unused-expressions: 0  */

import { isBefore } from 'date-fns';
import { ActionType } from './lib/enums';
import { gup } from './helpers/params';
import { getCookie, isBase64, parseBase64 } from './helpers/cookies';

/**
 * Define local storage key.
 */
const localStorageKey = 'cui';

const {
	btoa,
	atob,
	notifications,
	hasStorage = [],
	ccenabled,
	ccoffset = 1,
} = window;
const {
	userLoggedIn,
	// falconUser,
	// isExternal,
	// memberStatus,
	// memberActive,
	isIncomplete,
	froles = [],
} = window.accountData || {};

/**
 * Default user states.
 */
const defaultUS = {
	uiacap: 5,
	lastcat: null,
	uia: {}, // User interest area.
	lkp: '', // Last known position, zip.
	ac: {}, // Actions.
	no: {}, // Notifications.
	recs: [], // Article post ids recommended.
	seen: [], // Article post ids seen.
};

/**
 * Clone into actual object, preventing alteration of the default.
 */
const uS = Object.assign({}, defaultUS);
let initialState;

/**
 * Collect elements.
 */
const $navMenu = document.querySelector('.user-nav-menu ol');
const $navMenuMobile = document.querySelector('.user-logged-in.menu-item-has-children .sub-menu');
const $userBadge = document.querySelector('.user-badge');
const hasLogin = userLoggedIn || (hasStorage ? localStorage.getItem('hasLogin') : getCookie('hasLogin'));

/**
 * Native delegated events.
 */
const $on = (e, d, g, h, b) =>
	e.addEventListener(d, c => {
		for (d = e, b = c.target; b !== d;) b.matches(g) ? h.call(d = b, c, b) : b = b.parentNode
	});

/**
 * Get local stroage data.
 * If the decoded data is not valid, return the default state.
 *
 * @returns {string|Object}
 */
const getData = () => {
	const initialStorageString = localStorage.getItem(localStorageKey);
	return atob(initialStorageString) !== 'undefined' && isBase64(initialStorageString) ? parseBase64(initialStorageString) : uS;
};

/**
 * Return initial state.
 */
const printData = () => {
	const data = initialState;
	// console.log(data);
	return data;
};

/**
 * Push encoded data into localstorage.
 */
const saveData = () => {
	const encodedData = btoa(JSON.stringify(initialState));
	localStorage.setItem(localStorageKey, encodedData);
};

/**
 * Utility to reset data.
 */
const clearData = () => {
	const encodedData = btoa(JSON.stringify(defaultUS));
	localStorage.setItem(localStorageKey, encodedData);
};

/**
 * Expose data utility methods to window.
 */
window.getData = getData;
window.printData = printData;
window.saveData = saveData;
window.clearData = clearData;

// Set initial state.
initialState = getData();

/**
 * Get intersection between two arrays.
 */
const arraysIntersect = (a1, a2) => a1.filter(n => a2.indexOf(n) !== -1).length;

/**
 * Create slug for tracking.
 */
const createSlug = (title, url, roles) => {
	return btoa(title.replace(/[\u00A0-\u2666]/g, '') + url.replace(/[\u00A0-\u2666]/g, '') + roles.join(''));
};

/**
 * NOTFICATIONS.
 */
if (hasLogin && notifications && notifications.length) {
	let anyNotifications = false;

	// Expiration is handled by php.
	// Notifications via window global.
	notifications
		.reverse() // They'll be prepended in order, so need to be reversed.
		.forEach(notification => {
			const {
				notification_name,
				expire_date,
				roles = [],
				link: {
					title,
					url,
					target
				},
				hide_on_click = 'no',
			} = notification;

			/**
			 * Create slug for notification tracking.
			 */
			const slug = createSlug(title, url, roles);

			/**
			 * Should this hide?
			 */
			const shouldHide = hide_on_click === 'yes' && initialState && initialState.no[slug];

			/**
			 * Visiting a page with a notification once it's set should clear badge,
			 * even if not reached via a click.
			 */
			if (
				window.location.href.replace(/^https?:\/\//, '') ===
				String(url).replace(/^https?:\/\//, '')
			) {
				initialState.no[slug] = true;
			}

			/**
			 * Only show notifications with no roles or matching roles.
			 */
			if (!shouldHide && (!roles.length || arraysIntersect(roles, froles))) {
				if (!initialState.no[slug]) {
					anyNotifications = true;
				}
				const notifyClass = !initialState.no[slug] ? 'has-notification' : '';

				const template = document.createElement('template');
				template.innerHTML =
					`<li class="menu-item notification ${notifyClass}" data-slug="${slug}">
						<a data-notification-link ${hide_on_click === 'yes' ? 'data-click-hide ' : ' '}class="menu-item-link" href=${url}>${notification_name}</a>
					</li>`;

				const mobileTemplate = template.cloneNode(true);
				$navMenu.prepend(template.content.firstChild);
				$navMenuMobile.prepend(mobileTemplate.content.firstChild);
			}
		});

	/**
	 * Set the overall badge icon.
	 */
	if (anyNotifications || (userLoggedIn && isIncomplete)) {
		$userBadge.classList.add('has-notification');
	}

	/**
	 * Record clicked on notification
	 */
	$on(document.body, 'click', '[data-notification-link]', (evt, matched) => {
		const href = matched.getAttribute('href');
		const target = matched.getAttribute('target');
		const { slug } = matched.parentElement.dataset;
		initialState.no[slug] = true;
		saveData();
		if (!target) {
			evt.preventDefault();
			window.location = href;
		}
	});
} else if (!notifications.length) {
	/**
	 * Clear out all old ones if none exist.
	 * Should also eventually cycle through and discard
	 * 	any a person has recorded but are no longer active on the page
	 */
	initialState.no = {};
	saveData();
}

// add clearData to dev instance for an easy to use button
// const template = document.createElement('template');
// template.innerHTML = `<li style="display:none"
// onclick="window.clearData();window.location.reload();"><a href="#">Clear Data</a></li>`;
// $navMenu.append(template.content.firstChild);

// Object -> "Tuple" Array (ordered by hit)
// const rankByHits = obj => Object.entries(obj).sort(([a, b], [y, z]) => z - b);

/**
 * RECOMMENDATIONS.
 * California Educator.
 */

/**
 * Grab all data changing items so we can loop through them.
 */
const allQualifiers = document.querySelectorAll('[data-uia-qualifier]');
const allConsumers = document.querySelectorAll('[data-uia-consumer]');
const allRecs = document.querySelectorAll('[data-uia-article-rec]');

/**
 * Categories that are too generic to bother recommending.
 */
const badCategories = [74, 295, 208, 63, 83];

/**
 * Curried function.
 */
const addHit = obj => key => {
	// console.log('trying ', key, 'ignored categories:', badCategories);
	if (badCategories.indexOf(Number(key)) === -1) {
		// console.log('hit from', key, obj[key], obj);
		obj[key] = obj[key] ? (obj[key] + 1) : 1;
	}
	// console.log(obj);
	return obj;
};

const updateUserI = addHit(initialState.uia);

/* Qualifiers first */
allRecs.forEach(el => {
	const { uiaArticleRec } = el.dataset;
	// Sets don't serialize, but they can guarantee uniqueness.
	// console.log({ uiaArticleRec, recs: initialState.recs });
	// console.log(initialState.recs);
	initialState.seen = [...new Set([...initialState.recs, uiaArticleRec])];
});

allQualifiers.forEach(el => {
	const { uiaQualifier } = el.dataset;
	// console.log('adding category', uiaQualifier);
	updateUserI(uiaQualifier); // Curried.
});

// Returns a tuple with the highest rated interest area (ties don't matter).
const sortedUIAs = Object.entries(initialState.uia).sort(([a, b], [k, v]) => b - v);

/**
 * Basic reveal function.
 *
 * @param {HTMLElement} el The node to show.
 */
const showEl = el => {
	el.style.visibility = 'visible';
	el.style.opacity = 1;
};

/**
 * Get a date in the past or future by month offset.
 *
 * @param {number} monthOffset The future/past offset.
 * @returns {Date} The offset calculated date.
 */
const getOldDate = monthOffset => {
	const date = new Date();
	date.setMonth(date.getMonth() - Number(monthOffset));
	return date;
};

/**
 * Validate date offset qualifier.
 *
 * @param {Date} date The date to check.
 * @param {number} offset The offset to check.
 * @returns {boolean} Whether the date is in the past or future.
 */
const dateQaulifier = (date, offset) => isBefore(date, getOldDate(offset));

/**
 * API request.
 *
 * @param {string} id The category id.
 * @param {number} offset The date offset as a number.
 * @param {Function} callback The callback to run on error.
 * @returns {Promise} The API response.
 */
async function requestArticles(id, offset, errCb) {
	const url = `/wp-json/wp/v2/cali-ed-api?educator-category=${id}&per_page=1&offset=${offset}`;
	const response = await fetch(url)
		.then(res => {
			if (!res.ok) {
				throw new Error(res.statusText);
			}
			return res.json();
		})
		.catch(err => {
			console.error(err);
			errCb();
		});
	return response;
}

/**
 * Handle swapping articles.
 */
const replaceMedia = (el, categoryId, offset = 0) => {
	// console.log('getting category', categoryId);
	const $links = el.querySelectorAll('[data-uia-link]');
	const $titles = el.querySelectorAll('[data-uia-title]');
	const $images = el.querySelectorAll('.compound-raster-main img');
	const $dates = el.querySelectorAll('[data-uia-date]');
	// const $categories = el.querySelectorAll('[data-uia-category]');

	requestArticles(categoryId, offset, () => { showEl(el); })
		.then(response => {
			const {
				id,
				date_formatted,
				title: { rendered: renderedTitle },
				image,
				image_alt = '',
				link,
				date_gmt = '',
			} = response[0];

			// Qualifiers.
			let suitable = true;

			/**
			 * Check if content is older than X months.
			 */
			if (!dateQaulifier(new Date(date_gmt), ccoffset)) {
				console.log('rec article is too old');
				suitable = false;
			}

			/**
			 * Do not proceed if:
			 * 	- The article is too old.
			 *  - There is no quality image.
			 */
			if (image && suitable) {
				console.log('replace');

				// Links.
				$links.forEach(item => {
					item.href = link;
				});

				// Titles.
				$titles.forEach(item => {
					item.innerText = `${renderedTitle}`;
				});

				// Images.
				$images.forEach(imageEl => {
					imageEl.style.opacity = 0;
					imageEl.removeAttribute('srcset');
					imageEl.setAttribute('alt', image_alt);
					imageEl.src = image;
					imageEl.onload = () => {
						imageEl.style.opacity = 1;
						imageEl.parentNode.parentNode.className += ' img-loaded';
						return true;
					};
				});

				// Dates.
				$dates.forEach(item => {
					item.innerText = date_formatted;
				});

				// For you notice.
				el.querySelectorAll('.latest__featured--custom').forEach(tag => {
					tag.removeAttribute('hidden');
					tag.style.display = 'inline-block';
				});

				/**
				 * If the article exists on the page remove it.
				 */
				const articleMayExist = document.querySelector(`.cali-ed__latest__inner [data-article="${id}"]`);
				if (articleMayExist) {
					articleMayExist.remove();
				}
			}
			setTimeout(() => showEl(el), 100);
		});
};

/**
 * Curated content check.
 * This is where it gets called if possible.
 */
if (ccenabled) {
	allConsumers.forEach((el, i) => {
		let offset = 0;
		const [category, value] = sortedUIAs.pop() || [];
		// console.log('using category or cc', sortedUIAs, 'on ', el);
		// console.log('category', category, 'value', value);

		if (category) {
			if (initialState.lastcat === category) {
				offset = 1;
				initialState.uia[category] = Math.max(1, value - 2);
				initialState.lastcat = null;
			} else {
				initialState.lastcat = category;
			}
			replaceMedia(el, category, offset);

			// reduce the category so it won't have double impact
			initialState.uia[category] = Math.max(1, value - 1);
		} else {
			showEl(el);
		}
	});
}

/**
 * Define action function.
 */
const takeAction = ({
	action,
	type = ActionType.CLICK,
}) => {
	if (action) {
		// console.log('action viewed', action, type);
		initialState.ac[action] = type;
		saveData();
	}
};

/**
 * View action function.
 */
const viewAction = action => takeAction({ action, type: ActionType.VIEW });

/**
 * Get all actions.
 */
const actionStack = document.querySelector('[data-action-stack]');

if (actionStack) {
	// click tracking only
	$on(actionStack, 'click', '[data-action-slug]', (evt, matched) => {
		const { actionSlug, hasThankYou } = matched.dataset;
		//console.log({ actionSlug, hasThankYou});
		takeAction({ action: actionSlug });
	});

	// remove any taken actions we can find on the page
	Object.entries(initialState.ac).forEach(([slug, type]) => {
		// console.log('looking for', slug, type);
		const action = actionStack.querySelector(`[data-action-slug="${slug}"]`);

		if (action && type === ActionType.CLICK) {
			action.remove();
		}
	});

	// show actions on the page
	actionStack.style.opacity = 1;

	actionStack.querySelectorAll('[data-action-slug]').forEach(el => {
		const { actionSlug } = el.dataset;
		if (!initialState.ac[actionSlug]) {
			viewAction(actionSlug);
		}
	});
}

// any action from the url, if that is possible at some point
const currentAction = gup('action');

if (currentAction) {
	takeAction({ action: currentAction });
}
window.takeAction = takeAction;

/**
 * CHECK ME.
 * At the end we want to reset the storage key.
 * Then force our initialState into storage, completing the work for this session.
 */
clearData();
saveData();
